import { Component, Input } from '@angular/core';

export interface SalesSplitRow {
  labelKey: string;
  amount: number;
  color: string;
  percent: number;
}

@Component({
  selector: 'app-sales-split-card',
  templateUrl: './sales-split-card.component.html',
  styleUrls: ['./sales-split-card.component.scss'],
  standalone: false,
})
export class SalesSplitCardComponent {
  /** Etiqueta del total; el default es la de Multi-evento del vendedor. */
  @Input() totalLabelKey = 'dashboard-seller.split.total';
  @Input() totalAmountLabel: string = '';
  @Input() rows: readonly SalesSplitRow[] = [];
}
